<template>

  <div class="" >
    <b-overlay :show="showoverlay" rounded="sm" class="col-md-12">
      <div class="clearfix row py-2 mb-2 no-margin">
        <div class="col-md-2 pr-0 cursor-pointer text-left pl-0">

          <b-form-group id="selected_date-group" label="Select Date [YYYY-MM-DD] *" label-for="selected_date">
            <b-input-group class="mb-3">
              <b-form-input id="selected_date" @change="getCustomList" name="selected_date" v-model="selected_date" type="text" placeholder="YYYY-MM-DD" autocomplete="off" ></b-form-input>
              <b-input-group-append>
                <b-form-datepicker @input="getCustomList" id="selected_date" :max="date_max" button-only right locale="en-US" v-model="selected_date"></b-form-datepicker>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

        </div>
        <div class="col-md-10 no-margin p-0">
          <div class="row d-flex justify-content-end no-margin">
            <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning" @click="previewOrDownload(0)">Preview Report</b-button>
            <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning" @click="resetView()">Reset Selection</b-button>
            <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning" @click="previewOrDownload(1)">Download Report (Excel)</b-button>
          </div>
        </div>
      </div>
      <div v-if="this.is_grid_diplayable" >

        <common-list-leave-report ref="leaveReport" :checkbox="checkbox" :leave_type_options="this.leave_type_options" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list-leave-report>        
    

      </div>
      <div v-else>
        <table class="table dataTable border">
          <thead>
            <tr>
              <th>SL</th>
              <th v-for="col in previewColumns" :key="col.key">{{ col.title }}</th>
              <th>In Time</th>
              <th>Out Time</th>
              <th>Duration(H)</th>
              <th>Extra/Incomplete(H)</th>
              <th>Status</th>
              <th>Attendance Type</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in preview_data" :key="data.employee_id">
              <td>{{ index + 1 }}</td>
              <td v-for="col in previewColumns" :key="col.key">{{ data[col.key] }}</td>
              <td>{{ data.check_in }}</td>
              <td>{{ data.checkout }}</td>
              <td>{{ data.worktime }}</td>
              <td v-if="data.is_negative == 1">[{{ data.extra_or_short }}]</td>
              <td v-else>{{ data.extra_or_short }}</td>
              <td><span :class="'text-' + data.status.variant">{{ data.status.text }}</span></td>
              <td>{{ data.type }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </b-overlay>
  </div>
</template>


<script>

import moment from 'moment'
export default{

  data(){
    const now = new Date();
    let sortOrders = {};
    let columns = [
      { label: "SL", name: "employee_id" },
      { label: "Employee Code", name: "employee_code" },
      { label: "Name", name: "name" },
      { label: "Email", name: "email" },
      { label: "Phone", name: "phone" },
      { label: "Department", name: "department" },
      { label: "Position", name: "jobposition" },
      { label: "Branch", name: "branch" },
      { label: "Manager", name: "manager" },
    ];

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
  
    

      pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
      selected_date: new Date().toISOString().split('T')[0],
      date_max: new Date().toISOString().slice(0, 10),
      selected: [],
      columns: columns,
      sortKey: 'name',
      sortOrders: sortOrders,
      checkbox:1,
      is_action:1, /* As this list have actions then is_action will be 1. Otherwise, it will be 0 */
      list_key:0, /* Component Key */
      custom_list:[],  /* Data List */
      default_column:['name','phone','email','jobposition','department','branch','leave_policy','leave_type'], /* Default Column List */
      appended_column:[
      ],
      leave_type_options:[],                /* Appended Column List  and there title and type */
      primary_key:'employee_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked,
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
      company_options:[],         /* Company Filterable options */

      tmp_custom_list:[],

      selected_fiscal_year: '',
      current_fiscal_year: now.getFullYear(),
      employee_ids: [],
      // new
      preview_data: '',
      is_preview: 0,
      is_grid_diplayable: 1,

      showoverlay : false,
      cached_enabled_fields: [],
    }
  },
  methods:{
    resetView: function()
    {
      this.is_grid_diplayable = 1;
      this.preview_data = '';
      this.selected = [];
      this.list_key +=1;
      this.cached_enabled_fields = [];
    },
    listReturn:function(data)
    {   
      this.selected = data;
    },
    getCustomList: function()
    { 
        if(!this.checkNet()) return false;


        if (this.selected_date > this.date_max) {
          this.$bvToast.toast('Selected date cannot be greater than today.', {
            title: 'Invalid Date',
            variant: 'danger',
            solid: true
          });
          this.selected_date = this.date_max;
          return;
        }

        let currentObj = this; 
        this.resetView() // 14 july 2025 asfaq
        
        axios.get(this.$api_url+'/leaveattendancereport/getcustomlist?flg=1&day_one='+this.selected_date+'&day_two='+this.selected_date).then(function(response){

            /* Assingning the list */ 
            this.tmp_custom_list = response.data.employee_data;
            this.leave_type_options = response.data.leave_type_options;
            /* Assingning the Options */ 
            this.company_options = response.data.options;

            /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
            if(this.tmp_custom_list.length > 0 )
            {
                this.tmp_custom_list.forEach(element => {

                        if(element.leave_type.length>0)
                        {
                            let types = [];
                            let type_ids = [];
                            element.leave_type.forEach(newelement => {

                                types.push(newelement.value);
                                type_ids.push(newelement.id);
                                
                                });

                                element.leave_types = types.join(" , ");
                                element.leave_type_ids = type_ids;
                        }
                        else
                        {
                            element.leave_types = 'Not Available';
                            element.leave_type_ids = [];

                        }
                     });
                
            }
            
            this.custom_list = this.tmp_custom_list;
            

            this.list_key = this.list_key + 1;
        }.bind(this)).catch(function (error){currentObj.serverError(error);});

    }, 

    previewOrDownload: function(flg) {
        if (!this.checkNet()) return false;


        if (this.selected_date > this.date_max) {
          this.$bvToast.toast('Selected date cannot be greater than today.', {
            title: 'Invalid Date',
            variant: 'danger',
            solid: true
          });
          this.selected_date = this.date_max;
          return;
        }


        if (!this.selected.selected) {
            this.$bvToast.toast("Please select employee(s) to generate report", {title: 'Error!', variant: 'danger', solid: true});
            return;
        }
        if (this.selected_date == '') {
            this.$bvToast.toast("Please select a date to generate report", {title: 'Error!', variant: 'danger', solid: true});
            return;
        }

        let config = {};

        if(flg == 1)
        {
          config = {
              responseType: 'blob' 
          }
        }

        this.showoverlay = true;

        let enabledFields = [];
        if (this.$refs.leaveReport) {
            const defaultFields = this.$refs.leaveReport.default_column || [];
            const appendedFields = (this.$refs.leaveReport.appended_column || []).map(col => col.value || col);
            const selectedFields = this.$refs.leaveReport.column_selected || [];
            enabledFields = [...defaultFields, ...appendedFields, ...selectedFields];
            this.cached_enabled_fields = enabledFields;
        } else {
            enabledFields = this.cached_enabled_fields || [];
        }
        enabledFields = enabledFields.filter(field => field !== 'leave_type');

        let formData = new FormData();
        formData.append('employee_ids', JSON.stringify(this.selected.selected));
        formData.append('date', this.selected_date);
        formData.append('is_export', flg);
        formData.append('enabled_fields', JSON.stringify(enabledFields));

        axios.post(this.$api_url + '/la/report/daily', formData, config)
        .then(response => {
            this.showoverlay = false;

            if (flg == 0) {
                this.preview_data = response.data;
                this.is_preview = 1;
                this.is_grid_diplayable = 0;
            } 
            else if (flg == 1) {
                const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
                const downloadLink = document.createElement('a');
                downloadLink.href = blobUrl;
                downloadLink.setAttribute('download', 'Daily_Report.xlsx');
                document.body.appendChild(downloadLink);
                downloadLink.click();

                // Cleanup
                setTimeout(() => {
                    window.URL.revokeObjectURL(blobUrl);
                    document.body.removeChild(downloadLink);
                }, 100);
            }
        })
        .catch(error => {
            this.showoverlay = false;
            this.serverError(error);
        });
    }

  },
  computed:
      {
        previewColumns() {
          const titleMap = {
            'employee_code': 'Employee Code',
            'name': 'Employee Name',
            'phone': 'Mobile Number',
            'email': 'Email',
            'jobposition': 'Designation',
            'designation': 'Designation',
            'department': 'Department',
            'branch': 'Branch',
            'leave_policy': 'Leave Policy',
            'leave_type': 'Leave Type',
          };

          const fields = this.cached_enabled_fields && this.cached_enabled_fields.length > 0
            ? this.cached_enabled_fields
            : ['employee_code', 'name', 'jobposition', 'department'];

          return fields.map(field => {
            let key = field;
            if (field === 'designation') key = 'jobposition';
            return {
              key: key,
              title: titleMap[field] || field.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
            };
          });
        },
        filteredData()
        {
          let filtered_list = this.custom_list;
          if (this.search)
          {
            filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

            if(filtered_list.length == 0)
              this.blankmsg = "Nothing found.";
          }

          this.people = filtered_list.length;

          return filtered_list;
        },
        paginatedData()
        {
          return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },
        selectAll: {
          get: function () {
            // return this.employees ? this.selected.length == this.employees.length : false;
            return this.filteredData ? this.selected.length == this.filteredData.length : false;
          },
          set: function (value) {
            let selected = [];
            if (value) {
              this.filteredData.forEach(function (user) {
                selected.push(user.employee_id);
              });
            }
            this.selected = selected;
          }
        },
      //   clickSelect()
      //   {
      //
      //     if(this.selected.length !=  this.selected_ids.length)
      //     {
      //       this.selected_ids = this.selected;
      //       let value = [];
      //       value[this.primary_key] = 0;
      //       value['action_id'] = 0;
      //       value['selected'] = this.selected;
      //       value['leave_type_id'] = this.search_by_filter.leave_type_id;
      //       this.$emit('childToParent',value);
      //     }
      //   },
      },
  created: function(){
    this.getCustomList();
  }
}
</script>

<style scoped>
.r-custom tr td
{
  width: 14.28571%;
}


</style>
